var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDislike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3316_25802)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.44409,
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "#FF3838"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9725 18.7103L27.6388 10.5291C27.405 8.63159 25.0537 7.94409 23.5 7.94409H14.8238C14.5487 7.94409 14.3012 8.01284 14.095 8.13659L12.115 9.31909H9.75C8.2925 9.31909 7 10.6116 7 12.0691V17.5691C7 19.0266 8.2925 20.3466 9.75 20.3191H12.5C13.7513 20.3191 14.4112 20.9378 15.7863 22.4503C17.0375 23.8253 16.9963 24.9253 16.6525 26.9466C16.5425 27.6341 16.735 28.3216 17.23 28.8991C17.7662 29.5453 18.5775 29.9441 19.375 29.9441C21.8912 29.9441 23.5 24.8428 23.5 23.0553L23.4725 21.7078H26.2775C27.8725 21.7078 28.9587 20.6078 29 18.9991C29 18.8478 28.9725 18.7103 28.9725 18.7103ZM26.2638 20.3466H23.5275C22.565 20.3466 22.1112 20.7316 22.1112 21.6803L22.1525 23.0966C22.1525 24.8428 20.5438 28.5966 19.4025 28.5966C18.715 28.5966 17.9175 27.9091 18.0275 27.2216C18.3713 25.0491 18.495 23.3991 16.8038 21.5291C15.4012 19.9753 14.37 18.9441 12.5 18.9441V10.6941L14.7963 9.31909H23.5C24.5037 9.31909 26.1812 9.74534 26.25 10.6941L26.2775 10.7216L27.6525 18.9716C27.6112 19.8516 27.13 20.3466 26.2775 20.3466H26.2638Z",
    fill: "#63171B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.44409,
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "#FF3838"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3316_25802"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(0 0.944092)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislike);
export default __webpack_public_path__ + "static/media/dislike.022099f49244bd47ceca6713c1198be2.svg";
export { ForwardRef as ReactComponent };